import React, { useEffect } from 'react'
import { useTranslation, Trans } from 'react-i18next'
import { Link } from 'react-router-dom'
import TwoCol from '../../partials/TwoCol'
import '../../sass/innerPages.sass'
import MainTitle from '../../partials/MainTitle'
import ds from '../../img/ds.jpg'
import colors from '../../img/colors.jpg'
import components from '../../img/components.jpg'
import cards from '../../img/cards.jpg'

function Ds() {
  const { t } = useTranslation();
  const dsPrototype = "https://www.figma.com/proto/BCusviI4UpWPfflyK6Slwu/Phone-number-dialing?page-id=47%3A1139&type=design&node-id=83-3161&viewport=2745%2C57%2C1&t=QjQrKZEBcjK1Cqh4-1&scaling=scale-down&starting-point-node-id=83%3A3161&show-proto-sidebar=1";
 
  useEffect(()=>{
    window.scrollTo(0, 0);
  },[])

  return (
    <div className='container'>
      <MainTitle title={t('dsTitle')} />
      <TwoCol contentOne={<ContentOne />} contentTwo={<ContentTwo />} />
      <div className='txtContainer mt-50 px-20'>
        <h2>{t('dsColors')}</h2>
        <p>{t('dsColorsTxt')}</p>
        <figure>
          <img className='image-fluid' src={colors} alt={t('dsColors')} />
          <figcaption>{t('dsColorsCaption')}</figcaption>
        </figure>
      </div>
      <div className='txtContainer mt-50 px-20'>
        <h2>{t('dsComponents')}</h2>
        <p>{t('dsComponentsTxt')}</p>
        <figure>
          <img className='image-fluid' src={components} alt={t('dsComponents')} />
          <figcaption>{t('dsComponentsCaption')}</figcaption>
        </figure>
      </div>
      <div className='txtContainer mt-50 px-20'>
        <h2>{t('dsCards')}</h2>
        <p>{t('dsCardsTxt')}</p>
        <figure>
          <img className='image-fluid' src={cards} alt={t('dsCards')} />
          <figcaption>{t('dsCardsCaption')}</figcaption>
        </figure>
        <p>{t('dsCardsTxt2')}</p>
        <Link className="btn btn-link btn-inner" to={dsPrototype} target="_blank">{t('seeHFPrototype')}</Link>
      </div>
    </div>
  )
}

export default Ds

function ContentOne() {
  const { t } = useTranslation();

  return(
    <img className="image-fluid" src={ds} alt={t('dsTitle')} />
  );
}

function ContentTwo() {
  const { t } = useTranslation();
  const dsPrototype = "https://www.figma.com/proto/BCusviI4UpWPfflyK6Slwu/Phone-number-dialing?page-id=47%3A1139&type=design&node-id=83-3161&viewport=2745%2C57%2C1&t=QjQrKZEBcjK1Cqh4-1&scaling=scale-down&starting-point-node-id=83%3A3161&show-proto-sidebar=1";

  return(
    <div className='innerMain mx-50'>
      <p className='mt-0'>{t('dsMainTxt')}</p>
      <Link className="btn btn-link mt-20" to={dsPrototype} target="_blank">{t('seePrototype')}</Link>
      <h2 className='mt-50 mb-0'>{t('mainProblem')}</h2>
       <p className='problem'><Trans i18nKey="dsMainText2">
        The main problem to solve was: <br/><i>How to design simple main design system with main components and responsive design.</i>
      </Trans></p>
    </div>
  );
}